import { css } from '@emotion/css'
import { colors } from '@dis/styles'

export const styles = {
  notificationConnection: (isWebsocket: boolean) => css`
    max-width: 478px;
    background: ${!isWebsocket ? colors.semantic.redLighter : colors.semantic.greenLighter};
  `,
}
